(() => {

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire21b6"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire21b6"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("70CzE", function(module, exports) {
//
// social-index/renderers
//

var $iC0Ns = parcelRequire("iC0Ns");

var $6LC3Y = parcelRequire("6LC3Y");

var $gGZpq = parcelRequire("gGZpq");

var $5HqoS = parcelRequire("5HqoS");

var $42xuH = parcelRequire("42xuH");
// index_selector_list_renderer - renders the si selector
// ----------------------------
// Responds to:
//    - si/set-group - set select option value; display the current selector list of indexes
//    - si/set-index - apply 'selected' state to matching index pill
//
// Hooks:
//   - js-si-selector:            wrapper for the entire selector area
//   - js-si-selector-list:       wrapper for the pills list - the IMMEDIATE parent of pills
//                                (nodes are inserted into this element)
//   - js-si-selector-list-item:  pill items
//   - js-si-selector-list-item-container: immediate parent of js-si-selector-list-item
//
const $51a67481a71c0a44$var$index_selector_list_renderer = function() {
    const el_selector_wrap = document.querySelector(".js-si-selector");
    const e = {
        group_select: el_selector_wrap.getElementsByTagName("select")[0],
        index_list: el_selector_wrap.querySelector(".js-si-selector-list")
    };
    let cur_group_name;
    function init() {
        window.addEventListener("si/set-group", cb_set_group);
        window.addEventListener("si/set-index", cb_set_index);
    }
    init();
    function cb_set_group(ev) {
        const group_name = ev.detail.group_name;
        if (group_name === cur_group_name) return;
        const group = $42xuH.find_group(group_name);
        if (!group) return;
        cur_group_name = group_name;
        e.group_select.value = group_name;
        set_index_pills(group["group-items"]);
    }
    function cb_set_index(ev) {
        $5HqoS.remove(cur_index_pills(), "s-selected");
        const pill = find_index_pill(ev.detail.index_name);
        if (pill) pill.classList.add("s-selected");
    }
    function set_index_pills(indexes) {
        clear_index_pills();
        const pills = indexes.map(function(si, i) {
            const el = (0, $6LC3Y.default)(`
        <a class="index-controls__pills__item-pos js-si-selector-list-item-container" style="animation-delay: ${i / 20}s;"
           data-ga="interaction" data-ga-action="click-control" data-ga-label="${si.name}">
          <span class="index-controls__pills__item js-si-selector-list-item">
            ${si.name}
          </span>
        </a>
      `);
            e.index_list.insertBefore(el, null);
            return el;
        });
    }
    function clear_index_pills() {
        const index_btns = cur_index_pills();
        if (index_btns.length) index_btns.forEach((0, $gGZpq.default));
    }
    function cur_index_pills() {
        return Array.from(e.index_list.getElementsByClassName("js-si-selector-list-item-container"));
    }
    function find_index_pill(index_name) {
        return cur_index_pills().find((el)=>el.textContent.trim() === index_name);
    }
}();
// si_index_description_renderer
// ----------------------------
// Responds to:
//    - si/set-index   - updates the current si title & description
//
// Hooks:
//    - js-c-si-description                 wrapper for the title block
//    - js-c-si-description-title           |
//    - js-c-si-description-time-period     |elements whose textContents is to be updated
//    - js-c-si-description-text            |
//
const $51a67481a71c0a44$var$si_index_description_renderer = function() {
    const el_descr_wrap = document.querySelector(".js-c-si-description");
    const e = {
        index_name: el_descr_wrap.querySelector(".js-c-si-description-title"),
        index_time_period: el_descr_wrap.querySelector(".js-c-si-description-time-period"),
        index_descr_text: el_descr_wrap.querySelector(".js-c-si-description-text")
    };
    function init() {
        window.addEventListener("si/set-index", cb_set);
    }
    init();
    function cb_set(ev) {
        const name = ev.detail.index_name;
        const description = $42xuH.find_index_prop(name, "description");
        const period = $42xuH.find_index_prop(name, "time-period") || window.social_index_default_time_period;
        update_index_name(name);
        update_index_time_period(period);
        update_index_descr(description);
    }
    function update_index_name(index_name) {
        e.index_name.textContent = index_name;
    }
    function update_index_time_period(time_period) {
        e.index_time_period.textContent = time_period;
    }
    function update_index_descr(description) {
        e.index_descr_text.textContent = description;
    }
}();
// si_table_renderer - main index (table) renderer
// ----------------------------
// Responds to:
//    - si/load-begin   - updates table visual state
//    - si/load-finish  - updates table visual state
//    - si/load-error   - updates table visual state
//
// Sends:
//    - si/render-finish
//
// Hooks:
//    - js-c-si-table:  wrapper for both table header & body
//    - js-c-si-list:   the table body
//    - js-c-si-row-header:  the header table row
//    - js-c-si-row:         a table row from the main table body
//    - js-si-load-error:  load-error-message container
//    - js-si-col-data:         a column element.
//                              the textContent of this element must be the data value
//    - js-si-col-data--total:  the 'total' column element
const $51a67481a71c0a44$var$si_table_renderer = function() {
    const el_wrap = document.querySelector(".js-si-table");
    const e = {
        wrap: el_wrap,
        list: document.querySelector(".js-c-si-list"),
        header_row: el_wrap.querySelector(".js-c-si-row-header")
    };
    function init() {
        window.addEventListener("si/load-begin", cb_begin_load);
        window.addEventListener("si/load-finish", cb_finish_load);
        window.addEventListener("si/load-error", cb_error);
        window.addEventListener("si/sort", cb_sort);
    }
    init();
    function disp__hide() {
        const el_error = document.querySelector(".js-si-load-error");
        if (el_error) (0, $gGZpq.default)(el_error);
    }
    function disp__remove_current() {
        cur_items().forEach((0, $gGZpq.default));
    }
    function disp__insert(items) {
        disp__remove_current();
        // CSS animation plays automatically when adding nodes to dom
        items.forEach(function(item, i) {
            item.setAttribute("style", `animation-delay: ${i / 60}s;`);
            e.list.appendChild(item);
        });
        window.dispatchEvent(new CustomEvent("si/render-finish"));
    }
    function cb_begin_load(ev) {
        disp__hide();
    }
    function cb_finish_load(ev) {
        const index_data = ev.detail;
        let items = index_data.map(create_row_el);
        items = sort_items_by_field(items, null, $42xuH.SORT_DESC);
        disp__insert(items);
    }
    function cur_items() {
        return Array.from(e.list.getElementsByClassName("js-c-si-row"));
    }
    function sort_items_by_field(_rows, i_field, direction) {
        let rows = _rows.slice();
        rows.sort(function(a, b) {
            const cols_a = a.getElementsByClassName("js-si-data-col");
            const cols_b = b.getElementsByClassName("js-si-data-col");
            const i_sortcol = i_field === null ? cols_a.length - 1 : i_field;
            const val_a = parseFloat(cols_a[i_sortcol].innerText);
            const val_b = parseFloat(cols_b[i_sortcol].innerText);
            return direction === $42xuH.SORT_DESC ? val_b - val_a : val_a - val_b;
        });
        return rows;
    }
    function cb_sort(ev) {
        const items = cur_items();
        if (items.length === 0) return;
        const reordered_list = sort_items_by_field(items, ev.detail.field_index, ev.detail.direction);
        disp__hide();
        disp__insert(reordered_list);
    }
    function cb_error(ev) {
        const txt = (0, $iC0Ns.default)("item_load_error");
        e.list.innerHTML = `
      <div class="index-load-error js-si-load-error">
        <h3 class="c-heading c-heading--2 c-heading--bottom-close">
          ${txt[0].replace("__INDEX_NAME__", ev.detail.index_name)}
        </h3>
        <p class="c-copy c-copy--2 measure-wide mx-auto">
          ${txt[1]}
        </p>
      </div>
    `;
    }
    function create_row_el(row) {
        const company_name = row[0].trim();
        const data = row.slice(1);
        // find logo
        const logo = function() {
            const logos = window.social_index_logos || [];
            const logo = logos.find((l)=>$42xuH.name_matches(l["company-name"], company_name));
            return logo ? logo["logo"] : null;
        }();
        const logo_snippet = !logo ? "" : `
      <div class="index-table__logo">
        <img class="index-table__logo__img" src="${logo}">
      </div>
    `;
        const has_logo = !logo ? "" : `
      index-table__col--has-logo
    `;
        return (0, $6LC3Y.default)(`
      <li class="index-table__row index-table__row--body js-c-si-row">
        <div class="index-table__row__pos">
          <div class="index-table__col index-table__col--title ${has_logo}">
            ${logo_snippet}
            ${company_name}
          </div>
          ${data.map(function(item, i) {
            const mods = i === data.length - 1 ? "js-si-data-col--total index-table__col--total" : "index-table__col--std";
            return `<div class="index-table__col js-si-data-col ${mods}">${item}</div>`;
        }).join("")}
        </div>
      </li>
    `);
    }
}();
// si_report_renderer
// ----------------------------
// Responds to:
//    - si/set-index - updates the displayed content item
//
const $51a67481a71c0a44$var$si_report_renderer = function() {
    const el_block = document.querySelector(".c-si-report-block");
    const e = {
        heading: el_block.querySelector(".c-heading"),
        text: el_block.querySelector(".c-content"),
        button: el_block.querySelector(".c-btn"),
        thumbnail: el_block.querySelector(".js-csrg-graphic-thumbnail")
    };
    function init() {
        window.addEventListener("si/set-index", cb_set);
    }
    init();
    function set_highlight_color(col) {
        const fills = Array.from(el_block.querySelectorAll("[fill]"));
        fills.forEach((item)=>item.setAttribute("fill", col));
    }
    function cb_set(ev) {
        const index_name = ev.detail.index_name;
        const item = $42xuH.find_index_prop(index_name, "content-item");
        if (!item) {
            el_block.style.display = "none";
            return;
        }
        el_block.style.display = "block";
        e.heading.innerHTML = $42xuH.find_index_prop(index_name, "content-header");
        e.text.innerHTML = $42xuH.find_index_prop(index_name, "content-text");
        e.button.href = $42xuH.find_index_prop(index_name, "content-url");
        if (e.thumbnail) e.thumbnail.src = $42xuH.find_index_prop(index_name, "content-thumb-url");
        set_highlight_color($42xuH.find_index_prop(index_name, "content-highlight-col"));
    }
}();

});
parcelRegister("iC0Ns", function(module, exports) {

$parcel$export(module.exports, "default", () => $d8cc64d13b4de2ac$export$2e2bcd8739ae039);
//
// localise.js - localisation function
//
// localise()
// -----------------------
// opts:
//     suppress_errors   bool    default: false
//     strings           array   default: the value of window.__localisations
//

var $9mNVc = parcelRequire("9mNVc");
const $d8cc64d13b4de2ac$var$l = window.__localisations || {};
const $d8cc64d13b4de2ac$var$cc = (0, $9mNVc.country_code)();
function $d8cc64d13b4de2ac$var$err(str, opts) {
    return opts.suppress_errors ? null : `localise.js error: string '${str}' not found`;
}
function $d8cc64d13b4de2ac$export$2e2bcd8739ae039(str, opts) {
    opts = opts || {};
    opts.suppress_errors = !!opts.suppress_errors;
    const strings = opts.strings || $d8cc64d13b4de2ac$var$l;
    if (!strings[str]) return $d8cc64d13b4de2ac$var$err(str, opts);
    const s = strings[str];
    if (s.constructor === String) return s;
    if (s[$d8cc64d13b4de2ac$var$cc]) return s[$d8cc64d13b4de2ac$var$cc];
    return $d8cc64d13b4de2ac$var$err(str, opts);
}

});
parcelRegister("9mNVc", function(module, exports) {

$parcel$export(module.exports, "is_de", () => $6d1ce47f1bc0df15$export$ff44b6523da18bc0);
$parcel$export(module.exports, "country_code", () => $6d1ce47f1bc0df15$export$e4aa15b3c9da1f7e);
//
// site-lang.js: helpers for determining the current languague site
//
function $6d1ce47f1bc0df15$var$html() {
    return document.documentElement;
}
function $6d1ce47f1bc0df15$export$a8836b7d59794cc() {
    const l = $6d1ce47f1bc0df15$var$html().lang;
    return l === "en" || l === "en-US";
}
function $6d1ce47f1bc0df15$export$ff44b6523da18bc0() {
    return $6d1ce47f1bc0df15$var$html().lang === "de-DE";
}
function $6d1ce47f1bc0df15$export$7cc6d900e09fec6d() {
    return $6d1ce47f1bc0df15$var$html().lang === "es-ES";
}
function $6d1ce47f1bc0df15$export$1400c39195b29403() {
    return $6d1ce47f1bc0df15$var$html().lang === "fr-FR";
}
function $6d1ce47f1bc0df15$export$e4aa15b3c9da1f7e() {
    if (!$6d1ce47f1bc0df15$export$e4aa15b3c9da1f7e.code) {
        if ($6d1ce47f1bc0df15$export$ff44b6523da18bc0()) $6d1ce47f1bc0df15$export$e4aa15b3c9da1f7e.code = "de";
        else if ($6d1ce47f1bc0df15$export$7cc6d900e09fec6d()) $6d1ce47f1bc0df15$export$e4aa15b3c9da1f7e.code = "es";
        else if ($6d1ce47f1bc0df15$export$1400c39195b29403()) $6d1ce47f1bc0df15$export$e4aa15b3c9da1f7e.code = "fr";
        else $6d1ce47f1bc0df15$export$e4aa15b3c9da1f7e.code = "en";
    }
    return $6d1ce47f1bc0df15$export$e4aa15b3c9da1f7e.code;
}

});


parcelRegister("6LC3Y", function(module, exports) {

$parcel$export(module.exports, "default", () => $4ed4a864cdd23a66$export$2e2bcd8739ae039);
//
// helpers/create-element.js - create element from string
//
function $4ed4a864cdd23a66$export$2e2bcd8739ae039(str) {
    let div = document.createElement("div");
    div.innerHTML = str;
    return div.firstElementChild;
}

});

parcelRegister("gGZpq", function(module, exports) {

$parcel$export(module.exports, "default", () => $c27034256b19aba7$export$2e2bcd8739ae039);
//
// helpers/remove-node.js - remove a dom node
//
function $c27034256b19aba7$export$2e2bcd8739ae039(n) {
    n.parentNode.removeChild(n);
}

});

parcelRegister("5HqoS", function(module, exports) {

$parcel$export(module.exports, "add", () => $4265726e5191c1cd$export$e16d8520af44a096);
$parcel$export(module.exports, "remove", () => $4265726e5191c1cd$export$cd7f480d6b8286c3);

var $3p6kg = parcelRequire("3p6kg");
function $4265726e5191c1cd$export$e16d8520af44a096(collection, class_list) {
    Array.from(collection).forEach((el)=>(0, $3p6kg.add_classes)(el, class_list));
}
function $4265726e5191c1cd$export$cd7f480d6b8286c3(collection, class_list) {
    Array.from(collection).forEach((el)=>(0, $3p6kg.remove_classes)(el, class_list));
}

});
parcelRegister("3p6kg", function(module, exports) {

$parcel$export(module.exports, "add_classes", () => $27a89d199fcb199c$export$b377786ff5e86c4c);
$parcel$export(module.exports, "remove_classes", () => $27a89d199fcb199c$export$63c4e52930b76567);
function $27a89d199fcb199c$export$b377786ff5e86c4c(el, classes) {
    classes.split(" ").forEach((c)=>el.classList.add(c));
}
function $27a89d199fcb199c$export$63c4e52930b76567(el, classes) {
    classes.split(" ").forEach((c)=>el.classList.remove(c));
}

});


parcelRegister("42xuH", function(module, exports) {
//
// social-index/helpers.js
//

var $717xZ = parcelRequire("717xZ");
// mq_list - listen for responsive state changes
// ----------------------------
const $2f11548be83e62a3$var$mq_list = matchMedia(`(max-width: ${$717xZ.bp_max.md})`);
// fuzzy name matching for index and company names/urls
// ----------------------------
// - NB. if you want fuzzy matching on spaces between words:
//     index_name    - version with spaces
//     test_name     - url slug or name possibly without spaces
//
function $2f11548be83e62a3$var$name_matches(index_name, test_name) {
    if (!index_name || !test_name) return false;
    test_name = test_name.replace("(", "\\(");
    test_name = test_name.replace(")", "\\)");
    test_name = test_name.replace(/[-  ]/gi, "[- \xa0]?");
    test_name = new RegExp(`^${test_name}$`, "i");
    return index_name.match(test_name);
}
// find an index property -> requested property / null
// ----------------------------
function $2f11548be83e62a3$var$find_index_prop(index_name, prop) {
    let index;
    $2f11548be83e62a3$var$call_for_matching_index(index_name, (si)=>index = si[prop]);
    return index;
}
// find group object from group name
// ----------------------------
function $2f11548be83e62a3$var$find_group(group_name) {
    return window.social_index_data.find((g)=>g["group-name"] === group_name);
}
// find indexes for group
// ----------------------------
function $2f11548be83e62a3$var$indexes_for_group(group_name) {
    let g = $2f11548be83e62a3$var$find_group(group_name);
    return g ? g["group-items"] : null;
}
// call supplied function for index matching name or url - cb: f(index_name, group_object)
// ----------------------------
function $2f11548be83e62a3$var$call_for_matching_index(index_name_or_url, f) {
    let groups = window.social_index_data;
    groups.forEach(function(g) {
        let matching_index = g["group-items"].find((si)=>$2f11548be83e62a3$var$name_matches(si["name"], index_name_or_url)) || g["group-items"].find((si)=>si["slug"] === index_name_or_url);
        if (matching_index) {
            f(matching_index, g);
            return;
        }
    });
}
// cb_after_anim() - run cb after an animation has completed
// ----------------------------
function $2f11548be83e62a3$var$cb_after_anim(el, cb) {
    let test_el = document.createElement("fakeelement");
    const animations = {
        "animation": "animationend",
        "OAnimation": "oanimationend",
        "MozAnimation": "animationend",
        "WebkitAnimation": "webkitAnimationEnd",
        "MsAnimationEnd": "msAnimationEnd"
    };
    function get_event_name() {
        for(let t in animations){
            if (test_el.style[t] !== undefined) return animations[t];
        }
    }
    el.addEventListener(get_event_name(), function(e) {
        if (e.target === el) cb();
    }, false);
}
let $2f11548be83e62a3$var$SORT_ASC = 0;
let $2f11548be83e62a3$var$SORT_DESC = 1;
module.exports = {
    name_matches: $2f11548be83e62a3$var$name_matches,
    find_index_prop: $2f11548be83e62a3$var$find_index_prop,
    find_group: $2f11548be83e62a3$var$find_group,
    indexes_for_group: $2f11548be83e62a3$var$indexes_for_group,
    mq_list: $2f11548be83e62a3$var$mq_list,
    cb_after_anim: $2f11548be83e62a3$var$cb_after_anim,
    SORT_ASC: $2f11548be83e62a3$var$SORT_ASC,
    SORT_DESC: $2f11548be83e62a3$var$SORT_DESC,
    invert_sort: function(sort) {
        return sort === $2f11548be83e62a3$var$SORT_ASC ? $2f11548be83e62a3$var$SORT_DESC : $2f11548be83e62a3$var$SORT_ASC;
    }
};

});
parcelRegister("717xZ", function(module, exports) {
//
// StyleVariables - Mirrored SASS vars
//
// Increment a min breakpoint value by one to get the max
function $51be7b1b3cb19108$var$set_bp_max(min_val) {
    return `${parseInt(min_val, 10) + 1}px`;
}
const $51be7b1b3cb19108$var$bp_min = {
    xs: "480px",
    sm: "600px",
    md: "900px",
    lg: "1200px",
    xl: "1500px",
    xxl: "1800px",
    nav_tray_switch: "1000px"
};
const $51be7b1b3cb19108$var$bp_max = {
    xs: $51be7b1b3cb19108$var$set_bp_max($51be7b1b3cb19108$var$bp_min.xs),
    sm: $51be7b1b3cb19108$var$set_bp_max($51be7b1b3cb19108$var$bp_min.sm),
    md: $51be7b1b3cb19108$var$set_bp_max($51be7b1b3cb19108$var$bp_min.md),
    lg: $51be7b1b3cb19108$var$set_bp_max($51be7b1b3cb19108$var$bp_min.lg),
    xl: $51be7b1b3cb19108$var$set_bp_max($51be7b1b3cb19108$var$bp_min.xl),
    xxl: $51be7b1b3cb19108$var$set_bp_max($51be7b1b3cb19108$var$bp_min.xxl),
    nav_tray_switch: $51be7b1b3cb19108$var$set_bp_max($51be7b1b3cb19108$var$bp_min.nav_tray_switch)
};
const $51be7b1b3cb19108$var$color_grey = {
    1: "#FCFCFC",
    2: "#F9F9F9",
    3: "#EEEEEE",
    4: "#C6C7CC",
    5: "#868690",
    6: "#51505A",
    7: "#303138",
    8: "#2A282F",
    9: "#27252C",
    10: "#252328"
};
const $51be7b1b3cb19108$var$color_logo = {
    lightblue: "#7FD6F8",
    green: "#8AC539"
};
const $51be7b1b3cb19108$var$color_hexicon = {
    blue: "#57B7DD",
    orange: "#F99132",
    purple: "#A98BBC",
    red: "#FF6D56",
    green: "#8AC539",
    yellow: "#FFBE0A"
};
module.exports = {
    bp_min: $51be7b1b3cb19108$var$bp_min,
    bp_max: $51be7b1b3cb19108$var$bp_max,
    color_logo: $51be7b1b3cb19108$var$color_logo,
    color_hexicon: $51be7b1b3cb19108$var$color_hexicon,
    color_grey: $51be7b1b3cb19108$var$color_grey
};

});



parcelRegister("lfLEC", function(module, exports) {
//
// social-index/controllers
//

var $3xAeK = parcelRequire("3xAeK");

var $5HqoS = parcelRequire("5HqoS");

var $4ywJO = parcelRequire("4ywJO");

var $42xuH = parcelRequire("42xuH");
// index_selector_list - sends events when a group or sector is selected
// ----------------------------
// responds to:
//    - change on si group select
//    - click on index list
//
// sends:
//    - si/set-group    detail: { group_name: x }
//    - si/set-index    detail: { index_name: x }
//
const $f78ff6cb2908ae5b$var$index_selector_list = function() {
    const el_selector_wrap = document.querySelector(".js-si-selector");
    const e = {
        group_select: el_selector_wrap.getElementsByTagName("select")[0],
        index_list: el_selector_wrap.querySelector(".js-si-selector-list")
    };
    function init() {
        e.group_select.addEventListener("change", cb_group_select_change);
        e.index_list.addEventListener("click", cb_index_item_click);
    }
    init();
    function cb_group_select_change(ev) {
        const group_name = e.group_select.value;
        window.dispatchEvent(new CustomEvent("si/set-group", {
            detail: {
                group_name: group_name
            }
        }));
        const indexes = $42xuH.indexes_for_group(group_name);
        if (indexes && indexes.length) {
            const index_name = indexes[0]["name"];
            window.dispatchEvent(new CustomEvent("si/set-index", {
                detail: {
                    index_name: index_name
                }
            }));
        }
    }
    function cb_index_item_click(ev) {
        if (ev.target.classList.contains("js-si-selector-list-item")) {
            const index_name = ev.target.textContent.trim();
            window.dispatchEvent(new CustomEvent("si/set-index", {
                detail: {
                    index_name: index_name
                }
            }));
        }
    }
}();
// si_load_controller - orchestrates loading & rendering of indexes
// ----------------------------
// responds to:
//    - si/set-index    - begins load & sends below events during the process
// sends:
//    - si/load-begin
//    - si/load-finish  : data
//    - si/load-error   : { reason: nonexistent / ajax error, index_name: Airlines }
//
const $f78ff6cb2908ae5b$var$si_load_controller = function() {
    let current_index_name;
    let load_in_progress;
    function init() {
        window.addEventListener("si/set-index", cb_set);
    }
    init();
    function cb_set(ev) {
        const index_name = ev.detail.index_name;
        // Prevent reloading of same index
        if (index_name === current_index_name) return;
        current_index_name = index_name;
        if (!load_in_progress) do_load(index_name);
    }
    function do_load(index_name) {
        load_in_progress = true;
        window.dispatchEvent(new CustomEvent("si/load-begin"));
        (0, $4ywJO.default)(index_name).then(function do_load__success(data) {
            load_in_progress = false;
            window.dispatchEvent(new CustomEvent("si/load-finish", {
                detail: data
            }));
        }).catch(function do_load__error(err) {
            load_in_progress = false;
            console.log("si_load_controller/set(): load error", err.message);
            window.dispatchEvent(new CustomEvent("si/load-error", {
                detail: {
                    reason: err.message,
                    index_name: index_name
                }
            }));
        });
    }
}();
// sort_controller - bind sort clicks, update header element state, send si/sort events
// ----------------------------
// Responds to:
//    - click on js-si-header-sort-col header elements - sends si/sort, updates header
//                                                       elements' state
//    - si/load-begin                                  - resets internal sort state, header
//                                                       element state
// Sends:
//    - si/sort         sort should occur   detail: { field_index: ~, direction: ~ }
//
// Hooks:
//    - js-si-header-sort-col:         header column items that can be clicked to trigger sort
//    - js-si-header-sort-col-title:   element within in the header column item wrapping the title
//    - js-si-data-col--total
const $f78ff6cb2908ae5b$var$sort_controller = function() {
    let header_items;
    let cur_sort_header;
    let cur_sort_direction = $42xuH.SORT_DESC;
    function init() {
        header_items = Array.from(document.getElementsByClassName("js-si-header-sort-col"));
        header_items.forEach((item)=>item.addEventListener("click", cb_sortby));
        window.addEventListener("si/load-begin", reset);
    }
    init();
    function get_total_sort_header_el() {
        return header_items.find((item)=>item.classList.contains("js-si-data-col--total"));
    }
    function cb_sortby(ev) {
        const el_sort_header = ev.currentTarget;
        const is_different_element = el_sort_header !== cur_sort_header;
        cur_sort_header = el_sort_header;
        if (is_different_element) cur_sort_direction = $42xuH.SORT_DESC;
        else cur_sort_direction = $42xuH.invert_sort(cur_sort_direction);
        update_sort();
    }
    function update_sort() {
        update_sort_header_attribs();
        const i = header_items.indexOf(cur_sort_header);
        window.dispatchEvent(new CustomEvent("si/sort", {
            detail: {
                field_index: i,
                direction: cur_sort_direction
            }
        }));
    }
    function update_sort_header_attribs() {
        const sort_class = cur_sort_direction == $42xuH.SORT_ASC ? "s-asc" : "s-desc";
        header_items.forEach((item)=>{
            item.classList.remove("s-asc");
            item.classList.remove("s-desc");
        });
        cur_sort_header.classList.add(sort_class);
    }
    function reset() {
        const sort_header = get_total_sort_header_el();
        const sort_direction = $42xuH.SORT_DESC;
        if (sort_header === undefined) return;
        if (sort_header !== cur_sort_header || sort_direction !== cur_sort_direction) {
            cur_sort_header = sort_header;
            cur_sort_direction = sort_direction;
        }
        update_sort_header_attribs();
    }
}();
// url_and_initial_load_controller
// ----------------------------
// - handles load of initially displayed index
// - and dynamic url updates on index selection by index_selector_list
// - because this one does first load, it runs after the others
//   to give them a chance to init
//
// responds to:
//    - si/set-index   - pushes a history state (updates the url)
//    - popstate       - pops the history stack
// sends:
//    - si/set-group   detail: { group_name: y }
//    - si/set-index   detail: { index_name: x,  page_load: bool }
//
const $f78ff6cb2908ae5b$var$url_and_initial_load_controller = function() {
    function init() {
        window.addEventListener("si/set-index", cb_set);
        window.addEventListener("popstate", cb_pop);
        const firstload_index = index_slug_for_url();
        set_index(firstload_index, true);
    }
    init();
    function index_slug_for_url() {
        const exp_path = "brandwatch-index";
        const i = location.pathname.indexOf(exp_path);
        if (i === -1) return null;
        const slug = function() {
            let slug = location.pathname.substr(i + exp_path.length);
            slug = slug.replace(/\//g, "");
            slug = decodeURIComponent(slug);
            return slug;
        }();
        return slug === "" ? window.social_index_default_index : slug;
    }
    function set_index(index_name_or_url_component, is_first_load) {
        const index_name = $42xuH.find_index_prop(index_name_or_url_component, "name") || window.social_index_default_index;
        const group_name = $42xuH.find_index_prop(index_name, "group-name");
        window.dispatchEvent(new CustomEvent("si/set-group", {
            detail: {
                group_name: group_name
            }
        }));
        window.dispatchEvent(new CustomEvent("si/set-index", {
            detail: {
                index_name: index_name,
                page_load: !!is_first_load,
                from_url_controller: true
            }
        }));
    }
    function cb_set(ev) {
        if (ev.detail.from_url_controller) {
            if (ev.detail.page_load) set_url(ev.detail.index_name, true);
            return;
        }
        set_url(ev.detail.index_name);
    }
    function set_url(index_name, replace_current_state) {
        const base_path = document.location.pathname.replace(/brandwatch-index.*/, "brandwatch-index");
        const url_part = $42xuH.find_index_prop(index_name, "slug");
        const path = `${base_path}/${url_part}`;
        if (replace_current_state) history.replaceState({
            index_name: index_name
        }, "", path);
        else history.pushState({
            index_name: index_name
        }, "", path);
        (0, $3xAeK.pageview)(path);
    }
    function cb_pop(ev) {
        let index_name = index_slug_for_url();
        set_index(index_name);
    }
}();
// index_load_effects_controller
// ----------------------------
// - handles the visual animation when switching between index
// - handles initial smooth load effects of the page
//
// Hooks:
//   - js-si-smooth-load:  apply to element to fade in on initial load
//   – js-si-panel:        outermost container of the index, used to fade when switching indexes
//   – js-si-panel__slide: used for slide in effect after index load. must not be the same
//                         element as js-si-panel
//   – js-si-loader:       loading spinner icon, shows status of load
const $f78ff6cb2908ae5b$var$index_load_effects_controller = function() {
    const index_loader = document.querySelector(".js-si-loader");
    const index_main_panel = document.querySelector(".js-si-panel");
    const index_main_panel_slide = document.querySelector(".js-si-panel__slide");
    const smooth_load_coll = document.getElementsByClassName("js-si-smooth-load");
    // Remove state on animation completion
    $42xuH.cb_after_anim(index_main_panel_slide, disp__disable_slide);
    function disp__disable_slide() {
        index_main_panel_slide.classList.remove("s-animated");
    }
    function disp__enable_slide() {
        index_main_panel_slide.classList.add("s-animated");
    }
    function disp__set_loading() {
        index_main_panel.classList.remove("s-index-loaded");
        index_loader.classList.add("s-show");
        disp__disable_slide();
    }
    function disp__finish_loading() {
        disp__enable_slide();
        index_main_panel.classList.add("s-index-loaded");
        index_loader.classList.remove("s-show");
    }
    function init() {
        window.addEventListener("si/load-begin", disp__set_loading);
        window.addEventListener("si/load-finish", disp__finish_loading);
        window.addEventListener("si/load-error", disp__finish_loading);
        index_main_panel_slide.classList.add("s-restore-flow");
        index_main_panel_slide.classList.add("s-animated");
        index_main_panel_slide.classList.add("s-page-loaded");
        $5HqoS.add(smooth_load_coll, "s-page-loaded");
    }
    init();
}();

});
parcelRegister("3xAeK", function(module, exports) {

$parcel$export(module.exports, "pageview", () => $2940900d1b2338bf$export$b81f1580747d8b3a);
//
// tracking.js - google analytics helper
//
function $2940900d1b2338bf$var$get_tracker() {
    if (window.ga && window.ga.getAll) {
        let trackers = window.ga.getAll();
        if (trackers.length) return trackers[0];
    }
    return null;
}
// pageview()
// -----------------------------
function $2940900d1b2338bf$export$b81f1580747d8b3a(location) {
    location = location || window.location.pathname;
    let tracker = $2940900d1b2338bf$var$get_tracker();
    if (tracker) tracker.send("pageview", location);
}

});

parcelRegister("4ywJO", function(module, exports) {

$parcel$export(module.exports, "default", () => $3513bb731bf882ce$export$2e2bcd8739ae039);
//
// social-index/fetch-index.js
//

var $l3pBN = parcelRequire("l3pBN");

var $dEHUR = parcelRequire("dEHUR");

var $42xuH = parcelRequire("42xuH");

var $8WR3L = parcelRequire("8WR3L");
// fetch_index(name) -> promise
// ----------------------------
// - errors: ajax error
//           nonexistent
//
function $3513bb731bf882ce$var$fetch_index(index_name) {
    let url = $42xuH.find_index_prop(index_name, "url");
    if (!url) return Promise.reject(Error("nonexistent"));
    url += "?rev=" + Date.now();
    return $l3pBN.get(url).then((text)=>$dEHUR(text)).then((text)=>$8WR3L(text, true)).catch((err)=>{
        throw Error("ajax error");
    });
}
var $3513bb731bf882ce$export$2e2bcd8739ae039 = $3513bb731bf882ce$var$fetch_index;

});
parcelRegister("l3pBN", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.get = $f53dbe2470989188$var$get;
module.exports.get_json = $f53dbe2470989188$var$get_json;
module.exports.post = $f53dbe2470989188$var$post;
//
// AJAX.js - simple promise-based ajax helpers
//
// request() - private, -> promise
// ---------------------------------
// errors (stringly typed):
//  - network error  - unreachable / interrupted
//  - request error  - 400 codes
//  - server error   - 500 codes
//  - aborted        - .abort() called
function $f53dbe2470989188$var$request(url, method, data_url_encoded, cb_progress) {
    var xhr = new XMLHttpRequest();
    var promise = new Promise(function(succeed, fail) {
        xhr.addEventListener("error", function() {
            fail("network error");
        });
        xhr.addEventListener("abort", function() {
            fail("aborted");
        });
        if (typeof cb_progress === "function") xhr.addEventListener("progress", cb_progress);
        xhr.addEventListener("readystatechange", function() {
            if (xhr.readyState !== 4) return;
            if (xhr.status >= 400 && xhr.status < 500) fail("request error");
            else if (xhr.status >= 500) fail("server error");
            else if (xhr.status === 0) fail("network error");
            else succeed(xhr.responseText);
        });
    });
    xhr.open(method, url, true);
    if (typeof data_url_encoded === "string") {
        xhr.setRequestHeader("Content-type", "application/x-www-form-urlencoded");
        xhr.send(data_url_encoded);
    } else xhr.send();
    return promise;
} // get() -> promise, errors same as request()
// ---------------------------------
function $f53dbe2470989188$var$get(url, cb_progress) {
    return $f53dbe2470989188$var$request(url, "get", null, cb_progress);
} // get_json() -> promise, errors: as request + 'invalid json'
// ---------------------------------
function $f53dbe2470989188$var$get_json(url, cb_progress) {
    return $f53dbe2470989188$var$get(url, cb_progress).then(function(response_text) {
        try {
            return JSON.parse(response_text);
        } catch (err) {
            throw "invalid json";
        }
    });
} // post() -> promise, errors: as request + 'invalid post data'
// ---------------------------------
// errors - in addition to reqest():
//  - invalid post data
function $f53dbe2470989188$var$post(url, data, cb_progress) {
    var data_url_encoded;
    if (typeof data === "string") data_url_encoded = data;
    else if (data.constructor === Object) // Convert to x-www-form-urlencoded string
    data_url_encoded = Object.keys(data).map(function(k) {
        return $f53dbe2470989188$var$get_data_component(k, data[k]);
    }).join("&");
    else return Promise.reject("invalid post data");
    return $f53dbe2470989188$var$request(url, "post", data_url_encoded, cb_progress);
} // get_data_component() - x-www-form-urlencoded encoding helper
// ---------------------------------
function $f53dbe2470989188$var$get_data_component(key, value) {
    if (value === true) value = "yes";
    else if (value === false) value = "no";
    else if (value === null || value === undefined) value = "";
    else if (value.constructor === Array && value.length === 0) value = "";
    else if (value.constructor === Array) {
        key += "[]";
        return value.map(function(v) {
            return "".concat(encodeURIComponent(key), "=").concat(encodeURIComponent(v));
        }).join("&");
    }
    return encodeURIComponent(key) + "=" + encodeURIComponent(value);
} // interface
 // ---------------------------------

});

parcelRegister("dEHUR", function(module, exports) {
//
// helpers/html-decode.js - decode html entities
//
function $9f11139921814182$var$html_decode(str) {
    let el = document.createElement("div");
    el.innerHTML = str;
    return el.textContent;
}
module.exports = $9f11139921814182$var$html_decode;

});

parcelRegister("8WR3L", function(module, exports) {
//
// csv-parse.js - quick 'n dirty csv parser
//
// parse
// ---------------------------
function $683ce60ddb7e6e97$var$parse(s, remove_header_heuristically) {
    let rows = s.split(/[\r\n]+/).map((l)=>l.split(","));
    if (remove_header_heuristically) rows = $683ce60ddb7e6e97$var$remove_header(rows);
    return rows;
}
// remove_header
// ---------------------------
// - if the proportion of numerical fields in the first row is much less than
//   the average proportion of numerical fields in the table, remove the first row
const $683ce60ddb7e6e97$var$k = 0.25; // Incidence of numericals in header must be <k times their average incidence
function $683ce60ddb7e6e97$var$remove_header(rows) {
    if (rows.length < 2) return rows;
    let rows_without_header = rows.slice(1);
    let all_fields = [].concat.apply([], rows);
    let frac_numerical_rows__overall = $683ce60ddb7e6e97$var$n_items_that_are_numerical(all_fields) / all_fields.length;
    let frac_numerical_rows__header = $683ce60ddb7e6e97$var$n_items_that_are_numerical(rows[0]) / rows[0].length;
    if (frac_numerical_rows__header / frac_numerical_rows__overall < $683ce60ddb7e6e97$var$k) return rows_without_header;
    return rows;
}
function $683ce60ddb7e6e97$var$n_items_that_are_numerical(items) {
    return items.filter((item)=>!isNaN(item)).length;
}
module.exports = $683ce60ddb7e6e97$var$parse;

});



parcelRegister("irgDc", function(module, exports) {
//
// social-index/responsive-detail-view.js - detail view for mobile layouts
//
// Responds to:
//   - si/load-begin       - unbinds row click listeners
//   - si/render-finish    - binds row click listeners
//   - breakpoint change   - removes any open detail views
//
// Hooks:
//   - js-c-si-row-detail-view:     the row detail dropdown that activates on tap on a small screen
//   - js-si-header-sort-col-title: the header titles (used to populate the detail view).
//   - js-c-si-row
//   - js-si-data-col[--total]
//

var $6LC3Y = parcelRequire("6LC3Y");

var $gGZpq = parcelRequire("gGZpq");

var $9itWr = parcelRequire("9itWr");

var $94u83 = parcelRequire("94u83");

var $42xuH = parcelRequire("42xuH");
const $d6c7a63f8ec724aa$var$el_wrap = document.querySelector(".js-si-table");
function $d6c7a63f8ec724aa$var$get_header_titles() {
    return Array.from($d6c7a63f8ec724aa$var$el_wrap.getElementsByClassName("js-si-header-sort-col-title")).map((item)=>item.textContent.trim());
}
const $d6c7a63f8ec724aa$var$headers = $d6c7a63f8ec724aa$var$get_header_titles();
function $d6c7a63f8ec724aa$var$init() {
    window.addEventListener("si/load-begin", $d6c7a63f8ec724aa$var$unbind);
    window.addEventListener("si/render-finish", $d6c7a63f8ec724aa$var$bind);
    $42xuH.mq_list.addListener($d6c7a63f8ec724aa$var$cb_bp_change);
}
$d6c7a63f8ec724aa$var$init();
function $d6c7a63f8ec724aa$var$get_rows() {
    return Array.from($d6c7a63f8ec724aa$var$el_wrap.getElementsByClassName("js-c-si-row"));
}
function $d6c7a63f8ec724aa$var$bind(ev) {
    $94u83.add($d6c7a63f8ec724aa$var$get_rows(), "click", $d6c7a63f8ec724aa$var$cb_click);
}
function $d6c7a63f8ec724aa$var$unbind(ev) {
    $94u83.remove($d6c7a63f8ec724aa$var$get_rows(), "click", $d6c7a63f8ec724aa$var$cb_click);
}
function $d6c7a63f8ec724aa$var$cb_click(ev) {
    if (!$42xuH.mq_list.matches) return;
    const row = (0, $9itWr.default)(ev.currentTarget, "js-c-si-row");
    const is_open = row.classList.contains("s-active");
    $d6c7a63f8ec724aa$var$close();
    if (!is_open) {
        row.classList.add("s-active");
        $d6c7a63f8ec724aa$var$insert_detail_view(row);
    }
}
function $d6c7a63f8ec724aa$var$close() {
    $d6c7a63f8ec724aa$var$get_rows().forEach(function(r) {
        $d6c7a63f8ec724aa$var$remove_detail_view(r);
        r.classList.remove("s-active");
    });
}
function $d6c7a63f8ec724aa$var$remove_detail_view(row) {
    row.classList.remove("s-active");
    let detail_view = row.querySelector(".js-c-si-row-detail-view");
    if (detail_view) (0, $gGZpq.default)(detail_view);
}
function $d6c7a63f8ec724aa$var$insert_detail_view(row) {
    let values = Array.from(row.querySelectorAll(".js-si-data-col:not(.js-si-data-col--total)")).map((item)=>item.textContent);
    let el = (0, $6LC3Y.default)(`
    <div class="index-table__detail-view js-c-si-row-detail-view">
      ${$d6c7a63f8ec724aa$var$headers.map(function(heading, i) {
        return `
          <div class="index-table__detail-view__item" style="animation-delay: ${i / 30}s;">
            <h4 class="index-table__detail-view__heading">${heading}</h4>
            <p class="index-table__detail-view__value">${values[i]}</p>
          </div>
        `;
    }).join("")}
    </div>
  `);
    row.appendChild(el, row.firstElementChild);
    return el;
}
function $d6c7a63f8ec724aa$var$cb_bp_change() {
    $d6c7a63f8ec724aa$var$close();
}

});
parcelRegister("9itWr", function(module, exports) {

$parcel$export(module.exports, "default", () => $6c4d0542f9fa4678$export$2e2bcd8739ae039);
//
// helpers/find-ancestor.js
//
// - find ancestor element having a given class, or null
//
// - NB the element is considered an 'ancestor' of itself, since this is
//   the most useful behaviour
//
function $6c4d0542f9fa4678$export$2e2bcd8739ae039(el, c) {
    do {
        if (el.classList.contains(c)) return el;
    }while ((el = el.parentNode) && el !== document);
    return null;
}

});

parcelRegister("94u83", function(module, exports) {

$parcel$export(module.exports, "add", () => $69abdbc56c4dcdcd$export$e16d8520af44a096);
$parcel$export(module.exports, "remove", () => $69abdbc56c4dcdcd$export$cd7f480d6b8286c3);
//
// helpers/collection-listener.js - add/remove events listeners for collections
//
function $69abdbc56c4dcdcd$export$e16d8520af44a096(collection, event, handler) {
    Array.from(collection).forEach((el)=>el.addEventListener(event, handler));
}
function $69abdbc56c4dcdcd$export$cd7f480d6b8286c3(collection, event, handler) {
    Array.from(collection).forEach((el)=>el.removeEventListener(event, handler));
}

});


// 
// _other.js
// 
//
// social-index/index.js - kick-off for social index
//
let $7ffc29849bc91928$var$el_si_selector = document.getElementsByClassName("js-si-selector");



if ($7ffc29849bc91928$var$el_si_selector.length > 0) {
    (parcelRequire("70CzE"));
    (parcelRequire("lfLEC"));
    (parcelRequire("irgDc"));
}






})();
//# sourceMappingURL=module-other.js.map
